export const FRONT_API_BASE_URL = 'https://api2.frontapp.com';

export const WIDGET_CONFIG = {
  DEFAULT_POSITION: 'bottom-right',
  ANIMATION_DURATION: 300,
  RECONNECT_INTERVAL: 5000,
  PING_INTERVAL: 30000,
  MESSAGE_TIMEOUT: 10000,
} as const;

export const SESSION_STORAGE_KEYS = {
  SESSION_ID: 'peptalk_session_id',
  CLIENT_ID: 'peptalk_client_id',
  WIDGET_STATE: 'peptalk_widget_state',
  TOKEN: 'peptalk_token',
  SESSION: 'peptalk_session',
  SESSION_STORAGE: 'peptalk_session_storage',
} as const;

export const SESSION_CONFIG = {
  TTL_DAYS: 5,
  TTL_MS: 5 * 24 * 60 * 60 * 1000, // 5 days in milliseconds
  CLEANUP_INTERVAL_MS: 60 * 60 * 1000, // 1 hour
} as const;

export const WEBSOCKET_EVENTS = {
  CONNECT: 'connect',
  DISCONNECT: 'disconnect',
  MESSAGE: 'message',
  SESSION_UPDATE: 'session_update',
  ERROR: 'error',
  PING: 'ping',
  PONG: 'pong',
} as const;

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
} as const;

/**
 * Lead qualification intent score thresholds (0-100 scale).
 * Used consistently by middleware-api (Front conversation body) and sidebar-app (header badge).
 */
export const LEAD_INTENT_SCORES = {
  /** Score >= 80: High intent lead */
  HIGH_INTENT: 80,
  /** Score >= 60: Medium intent lead */
  MEDIUM_INTENT: 60,
} as const;

export type IntentLevel = 'high' | 'medium' | 'low';

/** Display labels for each intent level */
export const INTENT_LEVEL_LABELS: Record<IntentLevel, string> = {
  high: 'High Intent',
  medium: 'Medium Intent',
  low: 'Low Intent',
};

/**
 * Get intent level from qualification score (0-100).
 */
export function getIntentLevel(score: number): IntentLevel {
  if (score >= LEAD_INTENT_SCORES.HIGH_INTENT) return 'high';
  if (score >= LEAD_INTENT_SCORES.MEDIUM_INTENT) return 'medium';
  return 'low';
}

/**
 * Get intent level from qualification score using custom thresholds.
 * Falls back to default thresholds if not provided.
 */
export function getIntentLevelWithThresholds(
  score: number,
  highThreshold: number,
  mediumThreshold: number
): IntentLevel {
  if (score >= highThreshold) return 'high';
  if (score >= mediumThreshold) return 'medium';
  return 'low';
}
